import { Fragment } from 'react'
import { Field } from 'redux-form'
import { SingleLineTextField } from '../../../../Common/Form'
import NextArrow from '../../../../Common/Cascader/CascaderWithSelectedPath/NextArrow'
import { Tip } from '@vzmi/shp_shared_compo'
import styles from './index.css'

const CurrentPath = props => {
  const { paths = [] } = props
  return (
    <>
      <Tip type='subTitle'>目前所在</Tip>
      {paths.map((path, index) => {
        return (
          <Fragment key={path}>
            {index !== 0 && <NextArrow />}
            <Field
              name={path}
              component={SingleLineTextField}
              className={styles.path}
            />
          </Fragment>
        )
      })}
    </>
  )
}

export default CurrentPath
